const oneEn = {
  footerCopyright: "One Magyarország Zrt.",
  urls: {
    aboutInvitech: "https://www.one.hu/onerol",
    businessServices: "https://www.one.hu/kozep-nagyvallalatok",
    certificates: "https://one.hu/aszf#tanusitvany-invitech",
    coServiceOffers: "https://www.one.hu/kozep-nagyvallalatok",
    dataProcessingCode: "https://www.one.hu/adatvedelem#invitech",
    dataProtection: "https://www.one.hu/adatvedelem#invitech",
    forInstitutions: "https://www.one.hu/kozep-nagyvallalatok/hasznos/invitech-kozbeszerzes",
    forLargeCompanies: "https://www.one.hu/kozep-nagyvallalatok",
    forSmallAndMediumCompanies: "https://www.one.hu/kozep-nagyvallalatok",
    gtc: "https://one.hu/aszf#aszf-invitech",
    impress: "https://www.one.hu/jogi-nyilatkozat",
    infrastructureServices: "https://www.one.hu/kozep-nagyvallalatok",
    news: "https://www.one.hu/hirek-sajtokozlemenyek",
    premiumServices: "https://www.one.hu/kozep-nagyvallalatok",
    providerInformation: "https://one.hu/kozep-nagyvallalatok/hasznos/elerhetosegeink",
  },
};

export default oneEn;
